export default __webpack_public_path__ + "static/media/sunrise.29781269.svg";